export var formatOptions = {
    month: '2-digit',
    year: 'numeric',
};
export var formatUserMonthYear = function (date, locale) {
    return Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(date).replace(/ /g, '\xA0');
};
export var formatUserDate = function (date, locale) {
    return Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(date).replace(/ /g, '\xA0');
};
export var formatShortMonth = function (date, includeYear, locale) {
    if (includeYear === void 0) { includeYear = true; }
    return Intl.DateTimeFormat(locale, { month: 'short', year: includeYear ? 'numeric' : undefined })
        .format(date)
        .replace(/ /g, '\xA0');
};
export var formatYearMonthTag = function (date) {
    var yearMonth = Intl.DateTimeFormat('cs', formatOptions).formatToParts(date);
    return "".concat(yearMonth[2].value, "-").concat(yearMonth[0].value);
};
